import { request } from "utils/proxy";
import { API_HAZARD_SAFETY_PROTOCOLS } from "globals/constants";

const searchFacets = [
	{
		key: "title",
		text: "Title",
		facetType: "text"
	},
	{
		key: "protocolNumber",
		text: "Protocol #",
		facetType: "text"
	},
	{
		key: "primaryInvestigator",
		text: "PI",
		facetType: "text"
	}
];

const mapResults = results => results.map(result => {
	const { protocolNumber, title = "Title N/A", primaryInvestigatorName = "PI N/A" } = result;

	return {
		key: protocolNumber,
		text: `${protocolNumber} - ${title} - ${primaryInvestigatorName}`
	};
});

const fetchData = linkedProtocolIds => {
	if (!linkedProtocolIds.length) return Promise.resolve([]);
	const query = linkedProtocolIds.map(id => `protocolNumbers=${encodeURIComponent(id)}`).join("&");
	return request(`${API_HAZARD_SAFETY_PROTOCOLS}?${query}`, { notifyUponError: false });
};

const Helper = {
	apiKey: "protocolNumber",
	searchFacets,
	mapResults,
	fetchData
}

export default Helper;